import React, { useEffect, useState } from "react";
import "./marketing.scss";
import BreadCrumsHeader from "../../common/BreadCrums";
import { ReactComponent as CameraIcon } from "../../../Assets/Icons/cameraIcon.svg";
import { ReactComponent as CopyLinkIcon } from "../../../Assets/Icons/copyIcon.svg";
import { ReactComponent as BookmarkIcon } from "../../../Assets/Icons/bookmarkIcon.svg";
import { ReactComponent as ShareIcon } from "../../../Assets/Icons/shareIcon.svg";
import Input from "../../common/FormInputs";
import { useFormik } from "formik";
import { fundraiserMarketingSchema } from "../../../utils/validationSchemas";
import FormLayout from "../../common/FormLayout";
import ReactQuill, { Quill } from "react-quill";
import "react-quill/dist/quill.snow.css";
import UploadDocument from "../../common/OfferForm/UploadDocument";
import toast from "../../../utils/toast";
import GreyButton from "../../common/GreyButton";
import PrimaryButton from "../../common/PrimaryButton";
import { uploadFile } from "../../../utils/s3";
import { useDispatch, useSelector } from "react-redux";
import {
  addContent,
  getFundraiserContent,
  getFundraiserProfile,
} from "../../../services/fundraiserService";
import { useNavigate } from "react-router-dom";
import Loader from "../../common/Loader";
import ShareModal from "../../User/FundraiserBrandDetail/ShareModal";
import { Modal, Slider } from "antd";
import Cropper from "react-easy-crop";
import { getCroppedImgFile } from "../../../utils/cropImage";
import { ReactComponent as CloseIcon } from "../../../Assets/Icons/popupCloseIcon.svg";

// Marketing Page URL Component
const MarketingPageUrl = ({ userId, handlePublicLinkClick, content }) => {
  const [isBookmarked, setIsBookmarked] = useState(false);
  const [copySuccess, setCopySuccess] = useState(false);
  const [shareModalOpen, setShareModalOpen] = React.useState(false);

  const handleShareClick = () => {
    setShareModalOpen(true);
  };

  const handleCopy = () => {
    const textToCopy = window.location.origin + "/fundraiser-brand/" + userId;

    navigator.clipboard
      .writeText(textToCopy)
      .then(() => {
        setCopySuccess(true); // Show "Copied!" message
        setTimeout(() => setCopySuccess(false), 2000); // Revert after 2 seconds
      })
      .catch((err) => {
        console.error("Failed to copy: ", err);
      });
  };

  const toggleBookmark = () => {
    const currentURL = `${window.location.origin}/fundraiser-brand/${userId}`;
    try {
      // Most modern browsers do not allow programmatic bookmarking
      // Provide a helpful hint instead
      alert("Press Ctrl+D (Windows) or Cmd+D (Mac) to bookmark this page.");
      setIsBookmarked(true);
      setTimeout(() => setIsBookmarked(false), 1500);
    } catch (e) {
      console.warn("Bookmark action is not supported:", e);
    }
  };

  return (
    <div className="w-full md:w-[45%] mt-7 flex flex-col justify-start items-start">
      <p className="font-poppins font-[500] text-[14px] md:text-[16px] text-[#303030] mb-[0.75rem]">
        Marketing Page URL
      </p>
      <div className="w-full h-[45px] border border-[#D9D9D9] rounded-[5px] flex justify-between items-center px-2 relative bg-[#F4FCFF]">
        <p
          className="text-[#8C8C8C] font-poppins text-[12px] md:text-[14px] cursor-pointer overflow-hidden whitespace-nowrap text-ellipsis w-full"
          onClick={() =>
            handlePublicLinkClick(
              `${window.location.origin}/fundraiser-brand/${userId}`
            )
          }
          title={`${window.location.origin}/fundraiser-brand/${userId}`} // Shows full text on hover
        >
          {`${window.location.origin}/fundraiser-brand/${userId}`}
        </p>
      </div>

      <div className="flex items-center justify-start mt-2 gap-2">
        <div className="flex flex-col items-center justify-center mx-1">
          <CopyLinkIcon
            title="Copy Link"
            className="cursor-pointer"
            onClick={handleCopy}
          />
          <p className="font-poppins font-[400] text-[11px] md:text-[13px] text-[#303030] mt-1">
            {copySuccess ? "Copied!" : "Copy"}
          </p>
        </div>
        <div className="flex flex-col items-center justify-center mx-1">
          <BookmarkIcon
            title="Bookmark"
            className="cursor-pointer"
            onClick={toggleBookmark}
          />
          <p className="font-poppins font-[400] text-[11px] md:text-[13px] text-[#303030] mt-1">
            Bookmark
          </p>
        </div>
        <div className="flex flex-col items-center justify-center mx-1">
          <ShareIcon
            title="Share"
            className="cursor-pointer"
            onClick={handleShareClick}
          />
          <p className="font-poppins font-[400] text-[11px] md:text-[13px] text-[#303030] mt-1">
            Share
          </p>
        </div>
      </div>
      <ShareModal
        open={shareModalOpen}
        onClose={() => setShareModalOpen(false)}
        url={`${window.location.origin}/fundraiser-brand/${userId}`}
        content={content}
      />
    </div>
  );
};

const Marketing = () => {
  const dispatch = useDispatch();
  const loading = useSelector((state) => state?.fundraiserReducer?.loading);
  const userId = useSelector(
    (state) => state?.authReducer?.tokenData?.user?._id
  );
  const navigate = useNavigate();
  const [aboutHtml, setAboutHtml] = useState("");
  const [benefitsHtml, setBenefitsHtml] = useState("");
  const [logoFileImage, setLogoFileImage] = useState();
  const [logoFileData, setLogoFileData] = useState();
  const [bannerFileImage, setBannerFileImage] = useState();
  const [hasChanges, setHasChanges] = useState(false);

  const [logoUrl, setLogoUrl] = useState();
  const [bannerUrl, setBannerUrl] = useState();
  const [content, setContent] = useState();

  // Crop State
  const [isCropModalOpen, setIsCropModalOpen] = useState(false);
  const [selectedFileForCrop, setSelectedFileForCrop] = useState(null);
  const [previewUrlForCrop, setPreviewUrlForCrop] = useState(null);
  const [crop, setCrop] = useState({ x: 0, y: 0 });
  const [zoom, setZoom] = useState(1);
  const [croppedAreaPixels, setCroppedAreaPixels] = useState(null);
  const [isCropping, setIsCropping] = useState(false);

  const onCropComplete = (croppedArea, croppedAreaPixels) => {
    setCroppedAreaPixels(croppedAreaPixels);
  };

  const handleBannerFileSelect = (file) => {
    const localUrl = URL.createObjectURL(file);
    setSelectedFileForCrop(file);
    setPreviewUrlForCrop(localUrl);
    setIsCropModalOpen(true);
  };

  const handleCropSave = async () => {
    if (!selectedFileForCrop || !croppedAreaPixels) return;

    setIsCropping(true);
    try {
      const croppedFile = await getCroppedImgFile(
        previewUrlForCrop,
        croppedAreaPixels,
        0,
        { horizontal: false, vertical: false },
        selectedFileForCrop.name
      );

      const fileName = croppedFile.name;
      // Upload to S3
      const s3Url = await uploadFile(croppedFile, fileName);

      // Update Form
      setBannerUrl(s3Url);
      setFieldValue("banner", s3Url);

      const logoImageUrl = URL.createObjectURL(croppedFile);
      setBannerFileImage(logoImageUrl);

      setIsCropModalOpen(false);
      // Reset crop state
      setCrop({ x: 0, y: 0 });
      setZoom(1);
      setSelectedFileForCrop(null);
      setPreviewUrlForCrop(null);
      setHasChanges(true);

    } catch (error) {
      console.error("Crop/Upload error", error);
      toast.error("Failed to upload image");
    } finally {
      setIsCropping(false);
    }
  };

  const Font = Quill.import("formats/font");
  Font.whitelist = ["16px", "18px", "20px", "22px", "24px", "26px"];
  Quill.register(Font, true);

  const modules = {
    toolbar: [
      [{ header: [1, 2, 3, false] }],
      ["bold", "italic", "underline", "strike"],
      [{ list: "ordered" }, { list: "bullet" }],
      ["link"],
      ["clean"],
    ],
  };

  const formats = [
    "header",
    "font",
    "size",
    "bold",
    "italic",
    "underline",
    "strike",
    "color",
    "background",
    "align",
    "list",
    "bullet",
    "link",
    "image",
    "video",
  ];

  const getContent = async () => {
    const getPromise = await dispatch(
      getFundraiserContent({ userId: userId })
    )?.unwrap();
    if (getPromise?.success === true) {
      setContent(getPromise?.data);
    }
  };

  useEffect(() => {
    const fetchAllData = async () => {
      await getContent();
      try {
        const profileResp = await getFundraiserProfile();
        if (profileResp?.success) {
          const profile = profileResp.data;
          const orgName = profile?.organisationName || profile?.organizationName || profile?.fundraiserName || profile?.user?.name || profile?.name;
          setFieldValue("organisationName", orgName);
        }
      } catch (error) {
        console.error("Error fetching profile in marketing:", error);
      }
    };
    fetchAllData();
  }, []);

  const initialValues = {
    organisationName: "",
    logo: "",
    fundraiserTitle: "",
    aboutUs: "",
    benefits: "",
    banner: "",
    websiteURL: "",
  };

  const formik = useFormik({
    initialValues: initialValues,
    validationSchema: fundraiserMarketingSchema,

    onSubmit: async (values) => {
      console.log("Market values: ", values, bannerUrl, logoUrl);
      const payload = {
        aboutUs: values?.aboutUs,
        banner: bannerUrl,
        logo: logoUrl,
        support: values?.benefits,
        website: values?.websiteURL,
      };
      const addPromise = await dispatch(addContent(payload))?.unwrap();
      if (addPromise?.success === true) {
        window.open(`/fundraiser-brand/${userId}`, "_blank");
      }
    },
  });

  const {
    organisationName,
    logo,
    // fundraiserTitle,
    aboutUs,
    benefits,
    banner,
    websiteURL,
  } = formik.values;

  const {
    handleChange,
    handleBlur,
    errors,
    touched,
    setFieldValue,
    handleSubmit,
  } = formik;

  const resolveAssetUrl = (path) => {
    if (!path) return undefined;
    if (/^https?:\/\//i.test(path)) return path;
    return (process.env.REACT_APP_S3_URL || "") + path;
  };

  useEffect(() => {
    setFieldValue("logo", content?.logo);
    setLogoFileImage(resolveAssetUrl(content?.logo));
    setLogoUrl(content?.logo || "");
    setFieldValue("banner", content?.banner);
    setBannerFileImage(resolveAssetUrl(content?.banner));
    setBannerUrl(content?.banner || "");
    setFieldValue("aboutUs", content?.aboutUs);
    setFieldValue("benefits", content?.support);
    setFieldValue("organisationName", content?.user?.organisationName || content?.user?.organizationName || content?.organisationName || content?.organizationName || content?.user?.name);
    setFieldValue("websiteURL", content?.website);
    setHasChanges(false);
  }, [content]);

  const handleInputChange = (e) => {
    setHasChanges(true);
    handleChange(e);
  };

  const resetToServerValues = () => {
    setFieldValue("logo", content?.logo);
    setLogoFileImage(resolveAssetUrl(content?.logo));
    setFieldValue("banner", content?.banner);
    setBannerFileImage(resolveAssetUrl(content?.banner));
    setFieldValue("aboutUs", content?.aboutUs);
    setFieldValue("benefits", content?.support);
    setFieldValue("organisationName", content?.user?.organisationName || content?.user?.organizationName || content?.organisationName || content?.organizationName || content?.user?.name);
    setFieldValue("websiteURL", content?.website);
    setHasChanges(false);
  };


  const handleAboutChange = (html) => {
    setFieldValue("aboutUs", html);
    setAboutHtml(html);
    setHasChanges(true);
  };

  const handleSupportChange = (html) => {
    setFieldValue("benefits", html);
    setBenefitsHtml(html);
    setHasChanges(true);
  };

  const validateImage = (data) => {
    var idxDot = data.lastIndexOf(".") + 1;
    var extFile = data.substr(idxDot, data.length).toLowerCase();
    if (
      extFile == "jpg" ||
      extFile == "jpeg" ||
      extFile == "png" ||
      extFile == "svg"
    ) {
      return true;
    } else {
      return false;
    }
  };

  const handleUploadLogo = async (event) => {
    let logoBase64 = "";
    let fileName = event.target.files[0].name;
    setFieldValue("logo", fileName);
    const s3Url = await uploadFile(event.target.files[0], fileName);
    setLogoUrl(s3Url);
    let checkValidImage = validateImage(fileName);

    if (checkValidImage) {
      let logoImageUrl = URL.createObjectURL(event.target.files[0]);
      setLogoFileImage(logoImageUrl);
      localStorage.setItem("profilePic", logoImageUrl);
      setLogoFileData(event.target.files[0]);
      setHasChanges(true);
    } else {
      toast.error("Only jpg/jpeg, png, and svg files are allowed!", "warning");
    }
  };

  const handleClearLogo = () => {
    setFieldValue("logo", "");
    setLogoUrl("");
    setLogoFileImage(undefined);
    setLogoFileData(undefined);
    setHasChanges(true);
  };

  const handlePublicLinkClick = (url) => {
    window.open(url, "_blank");
  };

  return (
    <>
      {loading === true && <Loader />}
      <FormLayout
        title={"About"}
        content={
          <div className="w-full marketing">
            <div className="flex flex-col md:flex-row justify-between w-full">
              <div className="w-full md:w-[45%]">
                <Input
                  label="Organisation Name"
                  labelClassName="font-poppins font-[500] text-[14px] md:text-[16px] text-[#303030]"
                  placeholder="Organisation Name"
                  width="100%"
                  radius="5px"
                  InputDivClass="w-[100%] mt-7"
                  name={"organisationName"}
                  value={organisationName}
                  handleChange={handleChange}
                  handleBlur={handleBlur}
                  error={errors.organisationName}
                  touched={touched.organisationName}
                  disabled={true}
                />
                <Input
                  label="Website URL"
                  labelClassName="font-poppins font-[500] text-[14px] md:text-[16px] text-[#303030]"
                  placeholder="Add URL"
                  width="100%"
                  radius="5px"
                  InputDivClass="w-[100%] mt-7"
                  name={"websiteURL"}
                  value={websiteURL}
                  handleChange={handleInputChange}
                  handleBlur={handleBlur}
                  error={errors.websiteURL}
                  touched={touched.websiteURL}
                />
                <div className="flex mt-7 items-center gap-4 md:gap-8">
                  <div className="h-[80px] w-[80px] rounded-[10px] border-2 border-solid border-[#E4E3E4] flex justify-center items-center relative">
                    {logoFileImage !== undefined ? (
                      <>
                        <img
                          src={logoFileImage}
                          className="w-full h-full rounded-[10px] border border-solid border-[#E4E3E4] object-cover object-top"
                          style={{ objectPosition: 'center 30%' }}
                          alt="Logo"
                        />
                        <div
                          className="absolute -top-2 -right-2 h-5 w-5 bg-white rounded-full flex justify-center items-center cursor-pointer shadow-md"
                          onClick={handleClearLogo}
                        >
                          <svg
                            width="10"
                            height="10"
                            viewBox="0 0 10 10"
                            fill="none"
                            xmlns="http://www.w3.org/2000/svg"
                          >
                            <path
                              d="M1 1L9 9M1 9L9 1"
                              stroke="#535353"
                              strokeWidth="1.5"
                              strokeLinecap="round"
                            />
                          </svg>
                        </div>
                      </>
                    ) : (
                      <CameraIcon />
                    )}
                  </div>
                  <input
                    type="file"
                    id="fileInput"
                    hidden
                    accept=".jpg,.jpeg,.png,.svg"
                    onChange={handleUploadLogo}
                    onClick={(event) => {
                      event.target.value = null;
                    }}
                  />
                  {logoFileImage === undefined && (
                    <label
                      htmlFor="fileInput"
                      className="font-poppins font-[400] text-[12px] md:text-[14px] text-[#535353] cursor-pointer"
                    >
                      Upload logo
                    </label>
                  )}
                </div>
                {errors.logo && touched.logo ? (
                  <div className="ms-1 mt-1">
                    <span className="text-red-600 text-[12px] font-[600] text-start">
                      {errors.logo}
                    </span>
                  </div>
                ) : null}
              </div>
              <div className="hidden md:block w-[10%]"></div>
              <MarketingPageUrl
                userId={userId}
                handlePublicLinkClick={handlePublicLinkClick}
                content={content}
              />
            </div>
            {/* <Input
              label="Fundraiser Title"
              placeholder="Fundraiser Title"
              width="100%"
              radius="5px"
              InputDivClass="w-full md:w-[45%] mt-7"
              name={"fundraiserTitle"}
              value={fundraiserTitle}
              handleChange={handleChange}
              handleBlur={handleBlur}
              error={errors.fundraiserTitle}
              touched={touched.fundraiserTitle}
            /> */}
            <div className="w-full mt-12">
              <p className="font-poppins font-[500] text-[14px] md:text-[16px] text-[#303030] mb-2">
                About Us
              </p>
              <ReactQuill
                theme="snow"
                value={aboutUs ? aboutUs : aboutHtml}
                onChange={handleAboutChange}
                modules={modules}
                formats={formats}
                placeholder="Type here..."
                className="w-full h-[250px] md:h-[350px] mt-2 mb-10"
              />
            </div>
            {errors.aboutUs && touched.aboutUs ? (
              <div className="ms-1 mt-[4.25rem]">
                <span className="text-red-600 sm:text-[10px] md:text-[12px] font-[600] text-start">
                  {errors.aboutUs}
                </span>
              </div>
            ) : null}
            <div className="w-full mt-24">
              <p className="font-poppins font-[500] text-[14px] md:text-[16px] text-[#303030] mb-2">
                Why we need your support?
              </p>
              <ReactQuill
                theme="snow"
                value={benefits ? benefits : benefitsHtml}
                onChange={handleSupportChange}
                modules={modules}
                formats={formats}
                placeholder="Type here..."
                className="w-full h-[250px] md:h-[350px] mt-2 mb-10"
              />
            </div>
            {errors.benefits && touched.benefits ? (
              <div className="ms-1 mt-[4.25rem]">
                <span className="text-red-600 sm:text-[10px] md:text-[12px] font-[600] text-start">
                  {errors.benefits}
                </span>
              </div>
            ) : null}
            <div className="w-full mt-32 sm:mt-32 md:mt-24">
              <p className="font-poppins font-[500] text-[14px] md:text-[16px] text-[#303030] mb-2">
                Additional Visuals
              </p>
              <p className="font-poppins font-[400] text-[12px] md:text-[14px] text-[#767676]">
                Select or upload a picture
              </p>
              <UploadDocument
                thumbnail={banner}
                name={"banner"}
                iconText={"Upload Banner"}
                error={errors?.banner}
                touched={touched?.banner}
                setFieldValue={setFieldValue}
                parentDivClass={"h-[370px] sm:w-full md:w-[70%] mt-7"}
                setS3Url={(url) => {
                  setBannerUrl(url || "");
                  setHasChanges(true);
                }}
                logoFileImage={bannerFileImage}
                setLogoFileImage={setBannerFileImage}
                onFileSelected={handleBannerFileSelect}
                previewImageClass="w-full h-full object-cover rounded-[15px]"
                showChangeText={false}
                removeBtnType="blue"
                removeBorderOnPreview={true}
              />
            </div>
          </div>
        }
        actions={
          <>
            <GreyButton
              className={`w-[35%] lg:w-[14%] h-[45px] rounded-[5px] text-[16px] font-[500] ${hasChanges ? "cursor-pointer" : "cursor-not-allowed opacity-60"
                }`}
              label="Cancel"
              onClick={resetToServerValues}
              disabled={!hasChanges}
            />
            <PrimaryButton
              className={`w-[35%] lg:w-[14%] h-[45px] rounded-[5px] text-[16px] font-[500] font-montserrat ${hasChanges ? "cursor-pointer" : "cursor-not-allowed opacity-60"
                }`}
              label="Save"
              onClick={handleSubmit}
              disabled={!hasChanges}
            />
          </>
        }
      />
      <Modal
        title={null}
        open={isCropModalOpen}
        onCancel={() => {
          setIsCropModalOpen(false);
          setCrop({ x: 0, y: 0 });
          setZoom(1);
        }}
        closeIcon={
          <div className="marketing-modal-close-btn">
            <CloseIcon style={{ width: '14px', height: '14px', color: 'white' }} />
          </div>
        }
        centered
        width={600}
        className="marketing-adjust-image-modal"
        transitionName="ant-fade"
        maskTransitionName="ant-fade"
        footer={null}
      >
        <div className="flex flex-col items-center gap-4 py-6 px-6 marketing-modal-content-wrapper">
          <h3 className="w-full text-left font-poppins font-[600] text-[20px] text-[#303030] mb-1">
            Adjust Image
          </h3>
          {previewUrlForCrop && (
            <div className="relative w-full h-[300px] rounded-[10px] overflow-hidden bg-[#1a1a1a] shadow-inner">
              <Cropper
                image={previewUrlForCrop}
                crop={crop}
                zoom={zoom}
                aspect={2 / 1}
                onCropChange={setCrop}
                onCropComplete={onCropComplete}
                onZoomChange={setZoom}
              />
            </div>
          )}
          <div className="w-full flex items-center gap-4 mt-2">
            <span className="font-poppins text-[14px] font-[500] text-[#767676]">Zoom</span>
            <Slider
              className="flex-grow marketing-crop-slider"
              min={1}
              max={3}
              step={0.01}
              value={zoom}
              onChange={(v) => setZoom(v)}
              tooltip={{ open: false }}
            />
          </div>

          <div className="mt-4 flex flex-col items-center text-center">
            <div className="flex items-center justify-center gap-3 w-full">
              <button
                className="px-8 py-2 rounded-[5px] text-[#767676] font-poppins font-[500] text-[14px] hover:bg-gray-100 transition-colors disabled:opacity-50 disabled:cursor-not-allowed"
                onClick={() => {
                  setIsCropModalOpen(false);
                  setCrop({ x: 0, y: 0 });
                  setZoom(1);
                }}
                disabled={isCropping}
              >
                Cancel
              </button>
              <button
                className="px-8 py-2 rounded-[5px] bg-[#00ADEF] text-white font-poppins font-[500] text-[14px] hover:bg-[#0095d1] transition-all disabled:opacity-50 disabled:cursor-not-allowed flex items-center justify-center gap-2 min-w-[150px]"
                onClick={handleCropSave}
                disabled={isCropping}
              >
                {isCropping ? (
                  <span>Uploading...</span>
                ) : (
                  "Add Image"
                )}
              </button>
            </div>
          </div>
        </div>
      </Modal>
    </>
  );
};

export default Marketing;
